var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotFoundMask1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 560,
    viewBox: "0 0 160 560",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "#00BCDA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 240,
    r: 80,
    fill: "#00BCDA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.0107 480V320",
    stroke: "#C9F001",
    strokeWidth: 8.25,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0107 480V320",
    stroke: "#C9F001",
    strokeWidth: 8.25,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.999 469.284L40.0073 330.713",
    stroke: "#C9F001",
    strokeWidth: 8.25,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.287 439.995L10.7158 360.004",
    stroke: "#C9F001",
    strokeWidth: 8.25,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160 400.008H0",
    stroke: "#C9F001",
    strokeWidth: 8.25,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M149.287 360.004L10.7158 439.995",
    stroke: "#C9F001",
    strokeWidth: 8.25,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M119.999 330.713L40.0073 469.284",
    stroke: "#C9F001",
    strokeWidth: 8.25,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M136.569 456.573L23.4253 343.43",
    stroke: "#C9F001",
    strokeWidth: 8.25,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M136.569 456.573L23.4253 343.43",
    stroke: "#C9F001",
    strokeWidth: 8.25,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M157.28 420.704L2.73096 379.299",
    stroke: "#C9F001",
    strokeWidth: 8.25,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M157.28 379.299L2.73096 420.704",
    stroke: "#C9F001",
    strokeWidth: 8.25,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M136.569 343.43L23.4253 456.573",
    stroke: "#C9F001",
    strokeWidth: 8.25,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M100.701 322.732L59.2959 477.281",
    stroke: "#C9F001",
    strokeWidth: 8.25,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2959 322.732L100.701 477.281",
    stroke: "#C9F001",
    strokeWidth: 8.25,
    strokeMiterlimit: 10
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 560,
    r: 80,
    fill: "#00BCDA"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotFoundMask1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/not-found-mask-1.60eec918f2e9d2d172b1c9cb49405cb5.svg";